import { differenceInDays } from 'date-fns';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Stack, Text } from '@bonusly/design-system';
import { useCurrentCompany, useCurrentUser } from '@bonusly/who-am-i';

const OFFICE_HOURS_URL = 'https://calendly.com/bonusly-expert-office-hours';

interface TrialCardProps {
	isExpanded: boolean;
}

export const TrialCard: FC<TrialCardProps> = ({ isExpanded }) => {
	const { t } = useTranslation('navigation');
	const user = useCurrentUser();
	const company = useCurrentCompany();

	const hasTrialEndDate = !!company.trial_end_date && company.status === 'in_trial';

	if (!isExpanded || !user?.admin || !hasTrialEndDate || company.is_superadmin_initialized) return null;

	const daysRemaining = differenceInDays(new Date(company.trial_end_date), new Date());

	return (
		<Stack
			bgColor="bg.surface"
			borderRadius="md"
			border="1px solid"
			borderColor="border.default"
			p={4}
			my={2}
			spacing={2}
			overflow="hidden"
			opacity={isExpanded ? 1 : 0}
			transition="opacity 0.15s cubic-bezier(.4, 0, .2, 1)"
		>
			<Text fontSize={14} fontWeight="semibold" color="text.default" whiteSpace="nowrap">
				{t('trial_card.ends_in', { count: daysRemaining })}
			</Text>
			<Text fontSize={14} color="text.softer">
				{t('trial_card.office_hours_cta')}
			</Text>
			<Button as="a" href={OFFICE_HOURS_URL} target="_blank" variant="solid" colorScheme="secondary" whiteSpace="nowrap">
				{t('trial_card.office_hours_button')}
			</Button>
		</Stack>
	);
};
